module.exports = __webpack_public_path__ + "static/BTP_nospam-3722f5ccfb25bba9058258dd9ffffacd.png";